import { z } from 'zod';
/**
 * WebSocket Connection Query Parameters Schema
 * Validates query parameters for WebSocket $connect route
 *
 * Per ADR-015 (Schema Validation Technology)
 */
export const WebSocketConnectQuerySchema = z.object({
    token: z
        .string()
        .min(1, 'JWT token is required')
        .describe('JWT token for authentication'),
});
/**
 * Validate WebSocket connection query parameters
 * @throws ZodError if validation fails
 */
export function validateWebSocketConnectQuery(queryParams) {
    return WebSocketConnectQuerySchema.parse(queryParams);
}
//# sourceMappingURL=websocket.js.map